import { ApplicationDTO } from "./applicationDTO";
import { PatientDTO } from "./patientDTO";

export class Application implements ApplicationDTO {

  constructor(
    public applicationDate: string,
    public appStatusNotes: string,
    public applicationDocumentSet: any[],
    public applicationStatus: string,
    public id: number,
    public isUrgentAppointment: string,
    public notes: string,
    public appointmentDate?: Date,
    public appointmentDateStr?: Date,
  ) { }

  static CreateFromData(data: ApplicationDTO[]) {

    if (data && data.length) {
      return new Application(
        data[0].applicationDate,
        data[0].appStatusNotes,
        data[0].applicationDocumentSet,
        data[0].applicationStatus,
        data[0].id,
        data[0].isUrgentAppointment,
        data[0].notes,
        data[0].appointmentDate,
      )
    }
    return Application.CreateEmpty();
  }

  static CreateEmpty() {
    return new Application(
      '',
      '',
      [],
      "ACCEPTED",
      0,
      '',
      '',
      new Date(),)
  }
}
